module.exports = __webpack_public_path__ + "img/sign_out_white.4c5b07af.svg";